import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { Download, FileJson, FileSpreadsheet, FileText, Upload, X } from "lucide-react";
import {
  downloadAllTemplates,
  downloadAllTemplatesJson,
} from "../../helper-components/helper-function";
import { useFormikContext } from "formik";
import errorToast from "../../helper-components/error-toast";

const GrnCsvImport = ({
  grnCsvImportOpen,
  setGrnCsvImportOpen,
  setIsModalOpen,
  handleFileUpload = () => {},
  tempalteArray = [],
  prefixName = "gort",
  setCommonImportFileType,
}) => {
  const { values } = useFormikContext();


  const openCommonImport = (fileType) => {
    setCommonImportFileType?.(fileType);
    setIsModalOpen(true);
    setGrnCsvImportOpen(false);
  };

  const importOptions = [
    {
      key: "vendor",
      title: "Vendor Template",
      hint: "Import a CSV in this vendor's own format",
      icon: <FileSpreadsheet size={20} />,
      Trigger: "label",
      htmlFor: "csv-upload",
      onDownload: () => {
        if (values?.vendorTemplate?.length > 0) {
          downloadAllTemplates(values?.vendorTemplate);
        } else {
          errorToast("Template is not Available to Download");
        }
      },
    },
    {
      key: "common-csv",
      title: "Common Import (CSV)",
      hint: "Import a CSV in the standard format",
      icon: <FileText size={20} />,
      onImport: () => openCommonImport("csv"),
      onDownload: () => downloadAllTemplates(tempalteArray),
    },
    {
      key: "common-json",
      title: "Common Import (JSON)",
      hint: "Import a JSON file in the standard format",
      icon: <FileJson size={20} />,
      onImport: () => openCommonImport("json"),
      onDownload: () => downloadAllTemplatesJson(tempalteArray),
    },
  ];
  return (
    <Transition show={grnCsvImportOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={() => setGrnCsvImportOpen(false)}
      >
        <div className="flex min-h-screen px-4 text-center min-w-full">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4"
            enterTo="opacity-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-4"
          >
            <div className="mx-auto my-auto w-full max-w-[560px] text-left align-middle transition-all transform bg-white shadow-xl rounded-xl overflow-hidden">
              {/* Header */}
              <div className="flex items-center justify-between px-5 h-[3.25rem] border-b border-b-[var(--popup-border)]">
                <h2 className="text-[var(--popup-heading-fg-color)] text-[length:var(--popup-heading-font-size)] font-[var(--popup-heading-font-weight)]">
                  {prefixName === "gort" ? "GRN Import" : "Purchase Invoice Import"}
                </h2>
                <button
                  type="button"
                  onClick={() => setGrnCsvImportOpen(false)}
                  className="p-1 rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                  aria-label="Close"
                >
                  <X size={18} />
                </button>
              </div>

              <div className="px-5 py-5 flex flex-col gap-3">
                <p className="text-xs text-gray-500 mb-1">
                  Choose how you want to import items. Download the matching template first if you need one.
                </p>

                <input
                  type="file"
                  accept=".csv"
                  onChange={(e) => handleFileUpload(e, "vendor")}
                  className="hidden"
                  id="csv-upload"
                />

                {importOptions.map(({ Trigger = "div", ...opt }) => (
                  <div
                    key={opt.key}
                    className="flex items-center gap-3 p-3 rounded-[10px] border border-[var(--import-border)] bg-[var(--import-bg)] hover:shadow-sm transition-shadow"
                  >
                    <Trigger
                      htmlFor={opt.htmlFor}
                      onClick={opt.onImport}
                      className="flex flex-1 items-center gap-3 cursor-pointer min-w-0"
                    >
                      <span className="flex items-center justify-center shrink-0 w-10 h-10 rounded-lg bg-white border border-[var(--import-border)] text-[var(--import-fg)]">
                        {opt.icon}
                      </span>
                      <span className="flex flex-col min-w-0">
                        <span className="text-sm font-semibold text-[var(--import-fg)]">
                          {opt.title}
                        </span>
                        <span className="text-xs text-gray-500 truncate">
                          {opt.hint}
                        </span>
                      </span>
                      <Upload size={16} className="ml-auto shrink-0 text-[var(--import-fg)]" />
                    </Trigger>

                    <button
                      type="button"
                      onClick={opt.onDownload}
                      title="Download Template"
                      className="flex items-center gap-1.5 shrink-0 h-9 px-3 rounded-lg border border-[var(--download-border)] bg-white text-[var(--download-fg)] text-xs font-semibold hover:bg-[var(--download-bg)]"
                    >
                      <Download size={14} />
                      Template
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default GrnCsvImport;
